/// <reference path="../../svg.d.ts" />
import { Hash, FileText } from 'lucide-react';
import { getIconProps, IconProps } from '../../utils';
import QuantitySvg from '../../assets/ui/quantity.svg?react';
import WeightSvg from '../../assets/ui/weight.svg?react';
import CostSvg from '../../assets/ui/cost.svg?react';
import ValueSvg from '../../assets/ui/value.svg?react';
import PackageSvg from '../../assets/packing/package.svg?react';

// LoadMainIcon - uses the same package icon from packing types
export const LoadMainIcon: React.FC<IconProps> = props => {
  return <PackageSvg {...getIconProps(props)} />;
};

export const QuantityIcon: React.FC<IconProps> = props => {
  return <QuantitySvg {...getIconProps(props)} />;
};

export const WeightIcon: React.FC<IconProps> = props => {
  return <WeightSvg {...getIconProps(props)} />;
};

export const CostIcon: React.FC<IconProps> = props => {
  return <CostSvg {...getIconProps(props)} />;
};

export const ItemsCostIcon: React.FC<IconProps> = props => {
  return <ValueSvg {...getIconProps(props)} />;
};

export const OrderRefIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Hash {...iconProps} />;
};

export const OrderWaybillIcon: React.FC<IconProps> = props => {
  return <FileText {...getIconProps(props)} />;
};
